import React, { FunctionComponent, useState } from 'react';
import { TabContext } from '@mui/lab';
import {
  Card,
  CardContent,
  Container,
  SxProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import Breadcrumbs, {
  BreadcrumbOption,
} from '../../../components/BreadCrumb/Breadcrumbs';
import { ITabItem } from '../../../components/V2/Tabs/type2/TabBar';
import UsersList from './UsersList';

export type TState = {
  selectedTab: ITabItem;
};

const tableCardContainerStyles: SxProps = {
  borderRadius: '20px',
  boxShadow: '0px 14px 40px 0px #6E9DB22E',
};

const tabs: ITabItem[] = [
  {
    index: 0,
    key: 'completed',
    title: 'Completed',
  },
];

const constructBreadcrumbOptions = () => {
  const options: Array<BreadcrumbOption> = [
    {
      type: 'link',
      title: 'Home',
      link: `${process.env.PUBLIC_URL}`,
    },
    {
      type: 'text',
      title: 'Users',
      highlight: true,
    },
  ];

  return options;
};

const initialState: TState = {
  selectedTab: tabs[0],
};

const AdminUsersPage: FunctionComponent = () => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only('xs'));

  // State
  const [state] = useState({ ...initialState });

  const breadcrumbOptions = constructBreadcrumbOptions();

  return (
    <Container maxWidth="xl">
      <div style={{ padding: '30px 0' }}>
        <Breadcrumbs
          options={breadcrumbOptions}
          textColor="#647488"
          showDropDown={isXsScreen}
        />
      </div>
      <div>
        <Card sx={tableCardContainerStyles}>
          <CardContent sx={{ p: 0 }}>
            <TabContext value={state.selectedTab.index.toString()}>
              <UsersList />
            </TabContext>
          </CardContent>
        </Card>
      </div>
    </Container>
  );
};

export default AdminUsersPage;
